/* Pulse site nav: the header redesign (Andre, 2026-09-03) plus the three pieces
   that survived from the previous bar: the cart-bubble restore, the search
   slide-out and the scrolled state. */
(function () {
  if (window.__pulse_nav) return;
  window.__pulse_nav = true;

  /* Keep the design's cart button alive. The anchor carries Dawn's
     id="cart-icon-bubble", which cart-drawer.js / cart-notification.js overwrite
     with Dawn's own markup after an add-to-cart; put ours back and carry the
     count across. The count is always shown (the reference bar reads 0 ♥ 0 bag). */
  function cartButton() {
    var bag = document.getElementById('cart-icon-bubble');
    if (!bag) return;
    var pulseMarkup = bag.innerHTML;
    function paint(count) {
      var badge = bag.querySelector('[data-pulse-cart-count]');
      if (badge) badge.textContent = count;
    }
    new MutationObserver(function () {
      if (bag.querySelector('[data-pulse-cart-count]')) return;
      var injected = bag.querySelector('.cart-count-bubble span[aria-hidden]');
      var count = injected ? parseInt(injected.textContent.trim(), 10) || 0 : 0;
      var label = (bag.getAttribute('aria-label') || '').split(',')[0];
      bag.innerHTML = pulseMarkup;
      paint(count);
      bag.setAttribute('aria-label', label + ', ' + count + (count === 1 ? ' item' : ' items'));
    }).observe(bag, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cartButton);
  else cartButton();
})();

/* Slide-out search (Andre, 2026-08-18): the icon opens an input inside the bar,
   Escape or a second click closes it, Enter submits to the search page. */
(function () {
  var wrap = document.querySelector('[data-pulse-search]');
  if (!wrap) return;
  var toggle = wrap.querySelector('[data-pulse-search-toggle]');
  var input = wrap.querySelector('[data-pulse-search-input]');
  var form = wrap.querySelector('[data-pulse-search-form]');
  /* The root class is what the mobile rules key off (2026-08-27). The field's
     own `is-open` cannot reach the logo or the mail/account icons -- they are
     an ancestor's sibling and uncles of it -- and below 768px the bar has to
     give those up or there is no room for the field to open into. Same idiom
     as the `nav-open` and `pnav-open` classes this file already sets. */
  function open() {
    wrap.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('pulse-search-open');
    input.removeAttribute('tabindex'); setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    wrap.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('pulse-search-open');
    input.setAttribute('tabindex', '-1');
  }
  toggle.addEventListener('click', function () {
    if (wrap.classList.contains('is-open')) {
      if (input.value.trim()) { form.submit(); return; }
      close();
    } else { open(); }
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); toggle.focus(); } });
  document.addEventListener('click', function (e) { if (wrap.classList.contains('is-open') && !wrap.contains(e.target)) close(); });
})();

/* Header redesign behaviour (ported from preview/menu/menu.js, 2026-09-03). Everything hangs off
   the .pmg section wrapper; the one contract is window.PulseSizeScale. See the section's header
   comment for the five structural rules. */
(function () {
  var root = document.querySelector('.pmg');   /* the section wrapper (schema "class"), which holds the header, the panel and the drawer as siblings */
  if (!root) return;
  var panel = root.querySelector('[data-pmg-panel]');
  var drawer = root.querySelector('[data-pmg-drawer]');
  var html = document.documentElement;
  var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-pmg-trigger]'));
  var discs = Array.prototype.slice.call(root.querySelectorAll('[data-pmg-disc]'));
  var groupBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pmg-group-btn]'));
  var lists = Array.prototype.slice.call(root.querySelectorAll('[data-pmg-list]'));
  var openedBy = null, pinned = false, fuse = null;
  var desktop = window.matchMedia('(min-width: 1000px)');
  var header = root.querySelector('[data-pmg-header]');
  /* the panel and drawer hang from the MEASURED bottom of the fixed chrome, never a constant */
  function setTop() { root.style.setProperty('--pmg-top', Math.round(header.getBoundingClientRect().bottom) + 'px'); }
  /* WP4-A (2026-09-06): the bar RETRACTS on scroll. The scroll IIFE at the foot of this file
     sets data-scrolled on <html> past 8px, which moves .pulse-nav from top:3.4rem to top:0
     (pulse-sections.css). Measuring only on init/resize/load left --pmg-top 34px stale, so the
     mega panel and the phone drawer opened 34px below the bar. Re-measure whenever the bar
     actually moves: the scroll IIFE fires `pulse:navscroll` when the attribute FLIPS (not on
     every scroll event), and the bar's own transitionend catches the end of the animation.
     rAF-throttled so a burst of either collapses into one measurement, and NOT a second scroll
     listener -- the one in this file stays the single owner of the scroll. */
  var topRaf = 0;
  function setTopSoon() {
    if (topRaf) return;
    topRaf = requestAnimationFrame(function () { topRaf = 0; setTop(); });
  }
  setTop(); window.addEventListener('resize', setTop); window.addEventListener('load', setTop);
  window.addEventListener('pulse:navscroll', setTopSoon);
  header.addEventListener('transitionend', function (e) {
    if (e.target !== header) return;
    if (e.propertyName === 'top' || e.propertyName === 'transform' || e.propertyName === 'height') setTopSoon();
  });

  /* ---- size scale: the site's one preference key ---- */
  /* WP4-B (2026-09-06): window.PulseSizeScale owns the key, the migration off the legacy
     `pulse:gender` name, the normalisation and the <html> attribute. This file used to read and
     write localStorage directly and paint <html> itself, which skipped the module's migration
     and, worse, fired no onChange -- so a switch made here left every other surface behind.
     Read and write through the module only; the direct fallback is for the module being absent
     (it is inline in <head>, so that is a broken page rather than a race). */
  function scale() {
    if (window.PulseSizeScale && window.PulseSizeScale.get) return window.PulseSizeScale.get();
    return html.getAttribute('data-size-scale') === 'm' ? 'm' : 'w';
  }
  function setScale(g) {
    var S = window.PulseSizeScale;
    if (S && S.set) {
      /* The onChange subscriber below owns the DOM work, so calling reflectGender() here as
         well ran it twice for every switch. The ONE case the subscriber cannot cover is a
         set() that is a no-op: the module early-returns when the value is unchanged and fires
         no listeners, and the panel's hovered-gender override may have left the panel showing
         the other side. So reflect only in that case, and let the subscriber do the rest. */
      var noop = S.get && S.get() === g;
      S.set(g);
      if (noop) reflectGender(g);
      return;
    }
    html.setAttribute('data-size-scale', g);
    reflectGender(g);
  }
  function reflectGender(g) {
    panel.setAttribute('data-pmg-panel-gender', g);
    root.querySelectorAll('[data-href-w]').forEach(function (a) { a.setAttribute('href', a.getAttribute(g === 'm' ? 'data-href-m' : 'data-href-w')); });
    root.querySelectorAll('[data-pmg-dgender]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pmg-dgender') === g ? 'true' : 'false'); });
  }
  if (!html.getAttribute('data-size-scale')) html.setAttribute('data-size-scale', scale());
  reflectGender(scale());
  /* WP4-B: follow a switch made anywhere else (the PDP buy box, the size guide, the wall), so the
     drawer's gendered hrefs and its Women/Men pills are right without being reopened. The
     subscriber does the DOM work; set() above only commits -- that is what stops re-entry. */
  if (window.PulseSizeScale && window.PulseSizeScale.onChange) {
    window.PulseSizeScale.onChange(function (g) { reflectGender(g); });
  }

  /* ---- panel open / close, with the hover corridor ---- */
  function open(g, by) {
    /* Measure BEFORE placing the panel. The bar's `top` animates over 0.32s, so a panel opened
       during that flight would otherwise be positioned from whatever --pmg-top last held --
       a mid-transition value, or the pre-scroll one. The scroll and transitionend hooks keep
       it fresh over time; this keeps it correct at the instant it matters. */
    setTop();
    clearTimeout(fuse);
    if (g) {
      panel.setAttribute('data-pmg-panel-gender', g);
      triggers.forEach(function (t) { t.classList.toggle('is-hover', t.getAttribute('data-pmg-gender') === g); });
      /* The PANEL's gendered links follow the HOVERED gender, not the saved scale
         (measured 2026-09-05: on the women's scale, hovering Men relabelled the
         row "View all men's" but its href stayed womens-, so the click landed on
         the women's collection). Scoped to the panel: the drawer and the footer
         keep following the saved scale through reflectGender(). */
      panel.querySelectorAll('[data-href-w]').forEach(function (a) { a.setAttribute('href', a.getAttribute(g === 'm' ? 'data-href-m' : 'data-href-w')); });
    }
    if (panel.hidden) { panel.hidden = false; root.setAttribute('data-pmg-open', ''); html.classList.add('pnav-open'); }   /* pnav-open on <html>: pulse-split-hero.css switches the bar to ink over the hero while a panel is open */
    discs.forEach(function (d) { d.setAttribute('aria-expanded', 'true'); });
    if (by) openedBy = by;
  }
  function close() {
    clearTimeout(fuse);
    if (panel.hidden) return;
    panel.hidden = true; pinned = false;
    root.removeAttribute('data-pmg-open'); html.classList.remove('pnav-open');
    triggers.forEach(function (t) { t.classList.remove('is-hover'); });
    discs.forEach(function (d) { d.setAttribute('aria-expanded', 'false'); });
    reflectGender(scale());
  }
  function scheduleClose() { if (pinned) return; clearTimeout(fuse); fuse = setTimeout(close, 300); }

  triggers.forEach(function (t) {
    t.addEventListener('mouseenter', function () { if (desktop.matches) open(t.getAttribute('data-pmg-gender')); });
    t.addEventListener('click', function (e) {
      /* theme: commit the scale and let the link navigate. proof: commit, pin, stay. */
      var g = t.getAttribute('data-pmg-gender');
      setScale(g);
      if (root.hasAttribute('data-pmg-proof')) { e.preventDefault(); open(g, t); pinned = true; }
    });
  });
  discs.forEach(function (d) {
    d.addEventListener('click', function () {
      var g = d.getAttribute('data-pmg-disc');
      if (!panel.hidden && panel.getAttribute('data-pmg-panel-gender') === g && pinned) { close(); return; }
      open(g, d); pinned = true;
      var first = panel.querySelector('button, a'); if (first) setTimeout(function () { first.focus(); }, 40);
    });
  });
  /* close intent lives on the whole header (bar + panel), never on a single trigger */
  root.addEventListener('mouseleave', function () { if (desktop.matches) scheduleClose(); });
  root.addEventListener('mouseenter', function () { clearTimeout(fuse); });
  document.addEventListener('click', function (e) { if (!panel.hidden && !root.contains(e.target)) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!panel.hidden) { close(); if (openedBy) openedBy.focus(); }
    if (!drawer.hidden) closeDrawer();
  });
  /* keep the panel while focus is inside it; close when Tab leaves the header */
  root.addEventListener('focusout', function (e) {
    if (panel.hidden) return;
    if (e.relatedTarget && !root.contains(e.relatedTarget)) close();
  });

  /* ---- groups: hover, focus or click swaps the middle list ---- */
  function setGroup(id) {
    groupBtns.forEach(function (b) { var on = b.getAttribute('data-pmg-group-btn') === id; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    lists.forEach(function (l) { l.hidden = l.getAttribute('data-pmg-list') !== id; });
    panel.setAttribute('data-pmg-group', id);
  }
  groupBtns.forEach(function (b) {
    var id = b.getAttribute('data-pmg-group-btn');
    b.addEventListener('mouseenter', function () { setGroup(id); });
    b.addEventListener('focus', function () { setGroup(id); });
    b.addEventListener('click', function () { setGroup(id); });
  });
  var stylesTile = root.querySelector('[data-pmg-tile-styles]');
  if (stylesTile) stylesTile.addEventListener('click', function (e) { e.preventDefault(); setGroup('styles'); groupBtns[1].focus(); });

  /* ---- phone drawer ---- */
  var burger = root.querySelector('[data-pmg-burger]');
  function openDrawer() { setTop(); drawer.hidden = false; html.classList.add('pmg-open'); burger.setAttribute('aria-expanded', 'true'); setTimeout(function () { drawer.focus({ preventScroll: true }); }, 40); }   /* focus the drawer itself: a focused first button paints a ring on open */
  function closeDrawer() { drawer.hidden = true; html.classList.remove('pmg-open'); burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
  burger.addEventListener('click', function () { drawer.hidden ? openDrawer() : closeDrawer(); });
  root.querySelectorAll('[data-pmg-dgender]').forEach(function (b) { b.addEventListener('click', function () { setScale(b.getAttribute('data-pmg-dgender')); }); });
  root.querySelectorAll('[data-pmg-acc]').forEach(function (b) {
    b.addEventListener('click', function () {
      var body = document.getElementById(b.getAttribute('aria-controls'));
      var on = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', on ? 'false' : 'true'); body.hidden = on;
    });
  });
  /* focus stays inside the open drawer */
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button:not([disabled])'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  (desktop.addEventListener ? desktop.addEventListener.bind(desktop, 'change') : desktop.addListener.bind(desktop))(function () { close(); if (!drawer.hidden) closeDrawer(); });
})();


/* ===========================================================================
   THE MENU SETS THE SIZE SCALE -- ITS OWN IIFE, and that is the point.

   Andre, 2026-09-02: "I was in the Women's collection and then I clicked on the
   menu on mobile and went to Men's clearance, I was still in Women's."

   This first shipped INSIDE the mobile-drawer IIFE, which opens with
   `if (!root) return;` and `if (!groups.length) return;`. On any page where
   `.pnav-m` is absent or empty, that IIFE bails BEFORE reaching the listener and
   the handler was never registered at all -- so the fix worked in a test that
   happened to have a drawer and failed in the wild. A document-level handler
   must never sit behind another feature's guards.

   WHY IT IS NEEDED: the scale is a localStorage preference painted on <html>
   before first paint, so it survives navigation. Correct for a preference, wrong
   when the customer has just told us the gender by choosing a menu. The two
   groups mostly SHARE their destinations -- "Men's clearance" and "Women's
   clearance" are the same collection URL, as are New releases, Nova, Flow 2,
   Volt and Compare -- so the group is the only signal there is.

   `data-pnav-scale` was already rendered on the desktop panel and NOTHING READ
   IT; the attribute was inert on every surface. The mobile panel now carries it
   too, and this is the reader.

   Capture phase, and localStorage writes synchronously, so the value lands
   before the browser leaves the page.

   The href fallback catches gendered links ANYWHERE -- footer, cards, body copy.
   The leading slash is load-bearing: 'womens-dance-sneakers' CONTAINS
   'mens-dance-sneakers'.
   =========================================================================== */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a || !window.PulseSizeScale) return;

    var holder = a.closest('[data-pnav-scale], [data-pmg-panel]');
    var scale = holder ? (holder.getAttribute('data-pnav-scale') || holder.getAttribute('data-pmg-panel-gender') || '') : '';

    if (!scale) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/womens-') > -1) scale = 'w';
      else if (href.indexOf('/mens-') > -1) scale = 'm';
    }
    if (scale === 'w' || scale === 'm') window.PulseSizeScale.set(scale);
  }, true);
})();


/* The top bar retracts on the first scroll and the nav takes its place (Andre,
   2026-09-02: "as soon as the mouse starts to scroll, a white background
   appears. And the top scroll bar disappears").

   Site-wide, not just the homepage: this file is loaded by sections/pulse-nav
   .liquid, which sits in the header group, so it runs on every template. On the
   homepage the white background is the hero section's own `data-psh-solid`
   state, which now flips at the same 8px; everywhere else the bar is already
   white and only the retraction is visible.

   Its own top-level IIFE. A handler tucked inside another one behind that
   function's early return is exactly how the gender-scale fix failed on
   2026-08-31: it passed here and did nothing for Andre. */
(function () {
  var root = document.documentElement;
  var THRESHOLD = 8;   /* not 0: a rubber-band bounce at the top would flicker */
  var on = null;

  function apply() {
    var past = window.scrollY > THRESHOLD;
    if (past === on) return;          /* only touch the DOM when it actually changes */
    on = past;
    if (past) root.setAttribute('data-scrolled', '');
    else root.removeAttribute('data-scrolled');
    /* WP4-A (2026-09-06): the attribute flip is what MOVES the bar (top: 3.4rem -> 0), so it is
       also the moment --pmg-top goes stale. Announce it rather than adding a second scroll
       listener elsewhere: this IIFE stays the single owner of the scroll, and the announcement
       fires only on the flip, not on every scroll event. */
    try { window.dispatchEvent(new CustomEvent('pulse:navscroll', { detail: { scrolled: past } })); } catch (e) {}
  }

  window.addEventListener('scroll', apply, { passive: true });
  window.addEventListener('resize', apply, { passive: true });
  apply();   /* a reload part-way down the page must start in the right state */
})();
